import { AllowedPartners } from "@expert/expert-university";
import { useQuery } from "@tanstack/react-query";

import { getTrainingSessionsByEmployeeId } from "../api/requests";

export const useEmployeeTrainingSessions = (
    key: string,
    employeeId: string | null,
    partner: AllowedPartners,
    challengeId?: string,
    sessionId?: string,
) => {
    const { data, isFetching } = useQuery({
        queryKey: [`training-sessions-${key}`, employeeId, partner, challengeId, sessionId],
        queryFn: () => getTrainingSessionsByEmployeeId(employeeId, partner, challengeId, sessionId),
        refetchOnWindowFocus: false,
    });

    return { data: data?.items, isFetching };
};
